import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import effImg from "../../assets/Images/products/eff.png";
import tabImg from "../../assets/Images/products/tab.png";
import capsuleImg from "../../assets/Images/products/capsule.png";
import PowderImg from "../../assets/Images/products/protein-powder.png";
import proteinBarImg from "../../assets/Images/products/protein-bar.png";
import cosImg from "../../assets/Images/products/cos.png";

import uparrow from "../../assets/Images/home/up-arrow.png";

export const slugifyProduct = (str) =>
  String(str || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export default function ProductSection({
  onViewAll,
  products = [
    { id: 1, name: "EFFERVESCENT TABLETS", imageSrc: effImg },
    { id: 2, name: "TABLETS", imageSrc: tabImg },
    { id: 3, name: "CAPSULES", imageSrc: capsuleImg },
    { id: 4, name: "POWDER", imageSrc: PowderImg },
    { id: 5, name: "PROTEIN BAR", imageSrc: proteinBarImg },
    { id: 5, name: "COSMETICS", imageSrc: cosImg },
  ],
}) {
  const navigate = useNavigate();

const goToProduct = (product) => {
  navigate(`/products/${slugifyProduct(product.name)}`);
};

  const handleViewAll = () => {
    if (onViewAll) onViewAll();
    else navigate("/products");
  };

  const [visibleItems, setVisibleItems] = useState([]);
  const refs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleItems((prev) => {
              if (!prev.includes(entry.target.dataset.index)) {
                return [...prev, entry.target.dataset.index];
              }
              return prev;
            });
          }
        });
      },
      { threshold: 0.2 }
    );

    refs.current.forEach((el) => el && observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="w-full py-16 sm:py-20 lg:py-24 bg-[#F8FAF7] overflow-hidden">

      {/* INLINE CSS */}
      <style>{`
        .gradient-text {
          background: linear-gradient(135deg, #355931 0%, #A4BE2C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .product-card {
          transition: all 0.5s ease;
        }

        .product-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 25px 60px rgba(0,0,0,0.08);
        }

        .product-image img {
          transition: transform 0.7s ease;
        }

        .product-card:hover .product-image img {
          transform: scale(1.06);
        }

        .arrow-btn {
          transition: all 0.4s ease;
        }

        .product-card:hover .arrow-btn {
          background: #355931;
        }

        .product-card:hover .arrow-btn img {
          transform: rotate(45deg);
          filter: brightness(0) invert(1);
        }

        .arrow-btn img {
          transition: all 0.4s ease;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* HEADING */}
        <div className="text-center mb-14 lg:mb-20">

          {/* Small Label */}
          <p className="text-[#6B8A1A] tracking-[0.35em] text-[11px] font-semibold mb-4 uppercase">
            OUR PRODUCT RANGE
          </p>

          {/* Main Heading */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-[#355931] leading-tight">
            Health, Nutrition  <span className="gradient-text"> & Beauty Products  </span>
          
          </h2>

              {/* Underline */}
            <div
              className="
                w-24
                h-[2px]
                mx-auto
                mt-6
                mb-6
                dw-fade-up
              "
              style={{
                animationDelay: "240ms",
                background:
                  "linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)",
              }}
            />

          {/* Description */}
          <p className="max-w-2xl mx-auto text-gray-600 text-sm sm:text-base leading-relaxed px-2">
            Discover innovative nutraceutical, wellness, sports nutrition,
            and beauty solutions developed with advanced manufacturing
            and premium quality standards.
          </p>

        </div>

        {/* PRODUCT GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-14">

          {products.map((product, index) => (
            <div
              key={product.id}
              ref={(el) => (refs.current[index] = el)}
              data-index={index}
              onClick={() => goToProduct(product)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  goToProduct(product);
                }
              }}
              className={`
                product-card
                bg-white
                rounded-[30px]
                overflow-hidden
                border
                border-[#A4BE2C]/10
                cursor-pointer
                opacity-0
                translate-y-10
                ${
                  visibleItems.includes(index.toString())
                    ? "opacity-100 translate-y-0"
                    : ""
                }
                transition-all
                duration-700
              `}
            >

              {/* IMAGE */}
              <div className="product-image bg-[#F8FAF7] overflow-hidden p-6 sm:p-8">

                <img
                  src={product.imageSrc}
                  alt=""
                  className="
                    w-full
                    h-[220px]
                    sm:h-[260px]
                    object-contain
                  "
                />

              </div>

              {/* CONTENT */}
              <div className="p-5 sm:p-7">

                <div className="flex items-center justify-between gap-4">

                  <h3 className="text-xl sm:text-2xl font-serif text-[#355931] leading-snug">
                    {product.name}
                  </h3>

                  {/* ARROW */}
                  <div
                    className="
                      arrow-btn
                      w-11
                      h-11
                      rounded-full
                      bg-[#35593110]
                      flex
                      items-center
                      justify-center
                      flex-shrink-0
                    "
                  >
                    <img
                      src={uparrow}
                      alt=""
                      className="w-4 h-4 object-contain"
                    />
                  </div>

                </div>

              </div>

            </div>
          ))}

        </div>

        {/* BUTTON */}
        <div className="flex justify-center">

          <Link to={"/products"}>

            <button
              onClick={handleViewAll}
              className="
                cursor-pointer
                font-semibold
                py-3
                px-8
                rounded-full
                border
                border-[#355931]
                bg-[#355931]
                text-white
                hover:bg-transparent
                hover:text-[#355931]
                transition-all
                duration-500
                tracking-[0.15em]
                text-sm
                uppercase
              "
            >
              View All Products
            </button>

          </Link>

        </div>

      </div>
    </section>
  );
}